import { Component, ComponentInterface, Element, h, Host, Prop } from "@stencil/core";

export type ProgressBarVariant = "light" | "dark";

@Component({
    tag: "uic-progress-bar",
    styleUrl: "progress-bar.scss"
})
export class ProgressBar implements ComponentInterface {
    @Element() host: HTMLUicProgressBarElement;

    /** The current progress, relative to 100 or `max`, if defined */
    @Prop() readonly value: number = 0;

    /** The maximum value of the progress bar */
    @Prop() readonly max: number = 100;

    /** The variant to use. Use the "light" variant on dark backgrounds */
    @Prop() readonly variant: ProgressBarVariant = "dark";

    render() {
        return (
            <Host
                class={{
                    "uic-progress-bar": true,
                    [`uic-progress-bar--${this.variant}`]: true
                }}
            >
                <progress value={this.value} max={this.max}></progress>
            </Host>
        );
    }
}
